"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Properties is a simple registry to register properties.
 *
 * Existing Properties:
 *  GOOGLE_MAPS_API_KEY
 */
var Properties = /** @class */ (function () {
    function Properties() {
    }
    /**
     * Registers the property in the registry
     *
     * @param name the properties name
     * @param property the properties value
     */
    Properties.register = function (name, property) {
        this.propertiesMap[name.toUpperCase()] = property;
    };
    /**
     * Returns the property from the registry
     *
     * @param name the properties name
     */
    Properties.resolve = function (name) {
        return this.propertiesMap[name.toUpperCase()];
    };
    /**
     * The map where the properties are stored
     */
    Properties.propertiesMap = {};
    return Properties;
}());
exports.default = Properties;
